import { render, staticRenderFns } from "./DisplayTree.vue?vue&type=template&id=54fd37d9&scoped=true&"
import script from "./DisplayTree.vue?vue&type=script&lang=js&"
export * from "./DisplayTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd37d9",
  null
  
)

/* custom blocks */
import block0 from "./DisplayTree.vue?vue&type=custom&index=0&blockType=liquor-json-viewer&%3Ajson=json"
if (typeof block0 === 'function') block0(component)

export default component.exports